import { render } from "./InternetSpeedBox.vue?vue&type=template&id=6ac74fb9&scoped=true"
import script from "./InternetSpeedBox.vue?vue&type=script&lang=js"
export * from "./InternetSpeedBox.vue?vue&type=script&lang=js"

import "./InternetSpeedBox.vue?vue&type=style&index=0&id=6ac74fb9&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac74fb9"]])

export default __exports__